import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Heading,
  Text,
  ButtonsContainer
} from 'components/common/Elements/Elements';
import WithTooltip from 'components/common/Elements/WithTooltip/WithTooltip';

import { textToDate } from 'utils/common';
import AutoAssignToggle from '../AutoAssignToggle/AutoAssignToggle';

import classes from './FeatureInfo.module.scss';

const FeatureInfo = ({
  data,
  isVisibleButtons,
  handleCancel,
  handleOpenModal,
  action,
  isNotFiltered,
  totalRecords,
  limitCustomersSelect,
  featureId,
  featureName,
  autoAssignEnabled,
  onAutoAssignToggle
}) => {
  const { t } = useTranslation(['activity']);
  const createAgent = agent => {
    return [
      {
        title: `${t('activity:featureFlag.FEATURE_NAME')}:`,
        value: agent.name
      },
      {
        title: `${t('activity:featureFlag.DESCRIPTION')}:`,
        value: agent.description
      },
      {
        title: `${t('activity:filters.UPDATED_BY')}:`,
        value: agent.updatedByName
      },
      {
        title: `${t('activity:filters.UPDATE_DATE')}:`,
        value: textToDate(new Date(agent.lastModified))
      }
    ];
  };

  return (
    <div className={classes.cell_border}>
      <ul className={classes.cell_wrap}>
        {createAgent(data).map((item, index) => (
          <li className={classes.cell} key={index}>
            <Heading size={4} weight="r" className={classes.cell_title}>
              {item.title ? item.title : <>&nbsp;</>}
            </Heading>
            <Text>
              <Text type="s" size={6} weight="m" className={classes.cell_value}>
                {item.value ? item.value : <>&nbsp;</>}
              </Text>
              {item.additional ? (
                <Text
                  type="s"
                  size={6}
                  weight="m"
                  className={classes.cell_additional}
                >
                  &nbsp;
                  {item.additional}
                </Text>
              ) : null}
            </Text>
          </li>
        ))}
        {featureId && (
          <li className={classes.cell}>
            <AutoAssignToggle
              featureId={featureId}
              featureName={featureName}
              initialEnabled={autoAssignEnabled}
              onToggleSuccess={onAutoAssignToggle}
              disabled={
                data.status !== 'ReadyToAssign' && data.status !== 'Assigned'
              }
            />
          </li>
        )}
      </ul>
      {isVisibleButtons &&
        (totalRecords >= limitCustomersSelect ? (
          <WithTooltip text={t('activity:featureFlag.CUSTOMERS_LIMIT_TOOLTIP')}>
            <div>
              <ButtonsContainer
                handleCancel={handleCancel}
                handleOpenModal={handleOpenModal}
                action={action}
                btnEnable={true}
                classesBtn={
                  isNotFiltered ? { action: classes.btnAction } : undefined
                }
              />
            </div>
          </WithTooltip>
        ) : (
          <ButtonsContainer
            handleCancel={handleCancel}
            handleOpenModal={handleOpenModal}
            action={action}
            classesBtn={
              isNotFiltered ? { action: classes.btnAction } : undefined
            }
          />
        ))}
    </div>
  );
};

FeatureInfo.propTypes = {
  data: PropTypes.object,
  isVisibleButtons: PropTypes.bool,
  handleCancel: PropTypes.func.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  isNotFiltered: PropTypes.bool,
  action: PropTypes.string.isRequired,
  totalRecords: PropTypes.number,
  limitCustomersSelect: PropTypes.number,
  featureId: PropTypes.string,
  featureName: PropTypes.string,
  autoAssignEnabled: PropTypes.bool,
  onAutoAssignToggle: PropTypes.func
};

export default FeatureInfo;
